// extracted by mini-css-extract-plugin
module.exports = {"container":"LabelNew_container__1mgqY"};